import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useEffect, useState } from "react";
import { EMenuActions } from "../../store";
import { toast } from "react-toastify";

const WaiterCall = () => {
    const token = useSelector((state) => state.Company.auth_token);
	const C_URL = useSelector((state) => state.Company.c_url);
    const table = useSelector((state) => state.Company.tableNo);
    const waiterOption = useSelector((state) => state.Company.waiterCall);
    const SalesPoint = useSelector((state) => state.Company.SalesPoint);
    const storeId = useSelector((state) => state.Company.storeId);
    const selectedTable = useSelector((state) => state.Company.selected_table);
    const selectedTableId = useSelector((state) => state.Company.selected_tableId);
    const [selectedOption, setSelectedOption] = useState("");
    const dispatch = useDispatch();

    const handleWatercall = async () => {
        try {
            const response = await axios.post(
                `https://${C_URL}/api/v1/WaiterCallRequest`,
                {
                    callInfo: [
                        {
                            BranchId: storeId,
                            SalesPoint: SalesPoint,
                            TableNo: table || selectedTable,
                            TableId: selectedTableId,
                            CallOptionId: selectedOption,
                        },
                    ],
                },
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );
            console.log(response)
            if (response.status === 201) {
                dispatch(EMenuActions.setWaiterCall(false));
                toast.success("A waiter will be with you shortly", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                throw new Error("Unexpected response status");
            }
        } catch (error) {
            toast.error("Failed to make a request. Please try again.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const handleOptionSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    return (
        <div className="relative sm:w-[100%] md:w-[50%] lg:w-[30%] md:pb-2 bg-white rounded-b-lg m-auto pb-[0.5rem]">
            <div className="pt-2">
                {waiterOption.map((items) => (
                    <div key={items.Id} className="p-3 text-left capitalize py-5">
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                name="option"
                                className="mr-2"
                                value={items.Id}
                                onChange={() => handleOptionSelect(items.Id)}
                                checked={selectedOption === items.Id}
                            />
                            <span className="capitalize">{items.Name}</span>
                        </label>
                    </div>
                ))}
            </div>
            <div
                onClick={handleWatercall}
                className="p-3 text-center border border-secondary text-secondary mx-3 mb-5 cursor-pointer hover:border-dark hover:text-dark rounded-lg"
            >
                Make a request
            </div>
        </div>
    );
};

export default WaiterCall;
